export default __webpack_public_path__ + "static/media/IconDesc_IronPlates.256.a9607887.png";